var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneConsultationFaiLv2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 509",
    style: {
      enableBackground: "new 0 0 520 509"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F0C360;}\n\t.st3{fill:#FE9461;}\n\t.st4{fill:#FF6C42;}\n\t.st5{fill:none;stroke:#000000;stroke-width:31;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 579.9903,
    y1: 238.3946,
    x2: -10.0097,
    y2: 420.3946,
    gradientTransform: "matrix(6.123234e-17 1 1 -6.123234e-17 -75.2526 -11.977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF4647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    style: {
      stopColor: "#F66857"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF4647",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBA188"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520,254c0,140.3-116.4,254-260,254c-73.4,0-139.8-29.7-187-77.6c-0.4-0.4-0.8-0.8-1.2-1.2 c-1.4-1.4-2.8-2.9-4.2-4.4c-1.9-2-3.7-4.1-5.5-6.1c-1.1-1.2-2.1-2.4-3.1-3.7C22.1,371.2,0,315.1,0,254C0,113.7,116.4,0,260,0 S520,113.7,520,254z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.8,112c0,6,4.9,11,11,11c77,0,139.6,62.6,139.6,139.5c0,6,4.9,11,11,11c6.1,0,11-4.9,11-11 c0-89-72.5-161.5-161.6-161.5C249.7,101,244.8,105.9,244.8,112z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243,165.7c0,6,4.9,11,11,11c48.3,0,87.6,39.3,87.6,87.6c0,6,4.9,11,11,11c6,0,11-4.9,11-11 c0-60.4-49.2-109.5-109.6-109.5C247.9,154.8,243,159.6,243,165.7L243,165.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.8,333.2c10.2-9.4,26.1-8.7,35.5,1.5l45.4,49.3c9.4,10.2,8.7,26.1-1.5,35.5l-29.8,27.4 c-16.2,13-31.1,11.7-31.4,11.7c-6.3-1-18.8,1.6-28.1-1.1c-36.2-10.4-88.3-32.1-148.8-97.8C102.6,294,82,236.5,71.7,196.5 c-3.2-12.4-0.4-27-1.4-34.6c0-0.2-0.9-15,11.6-26.5c0.9-0.8,1.6-1.6,2.1-2.3l20.6-19.4l8.6-7.2c10.2-9.4,26.1-8.7,35.5,1.5 l45.4,49.3c9.4,10.2,8.8,26.1-1.5,35.5l-37.1,34.2c15.3,28.5,31.7,54.7,59.5,84.9c24.2,26.3,44.5,41.9,67.5,57.4L321.8,333.2 L321.8,333.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.1,442.6l-4.7,4.3c-16.2,13-31.1,11.7-31.4,11.7c-6.3-1-18.8,1.6-28.1-1.1c-36.1-10.4-88.3-32.1-148.8-97.8 C102.6,294,82,236.5,71.7,196.5c-3.2-12.4-0.4-27-1.4-34.6c0-0.1-0.2-3,0.7-7.1C92.2,321,245.9,410,376.1,442.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.9,113.1l27,29.3c-12.2-11.7-43.2-33.2-80.6,1.3l34-31.3C125.9,107.1,134.7,107.5,139.9,113.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.1,342l27,29.3c-12.2-11.7-43.2-33.2-80.6,1.3l34-31.3C334.1,336.1,342.9,336.4,348.1,342z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 447.7,
    y1: 79.8,
    x2: 66.5,
    y2: 422.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M451.8,82.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M437.5,68.5c0,0,8.1,7.7,10.2,9.8c2.1,2.1,6.3,6.6,7.3,7.7c1,1.1,3.8,4.3,3.8,4.3l0.1,0.1l-1,1l-19.6-16.9L437.5,68.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M445.7,76.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8,433.6l-0.4,0.3c0,0-5.3-5-7.6-7.7c-2.3-2.6-6.6-7.2-7.6-8.5s-5-5.9-5-5.9l-0.7-0.8l0.8-0.7l20.5,16.7V433.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneConsultationFaiLv2);
export default __webpack_public_path__ + "static/media/Phone_consultation_FAILv2.0cd16b11f5ed982aec5d84d303045670.svg";
export { ForwardRef as ReactComponent };